import {
  previewCss,
  TipTapNodeViewContent,
  TipTapNodeViewWrapper,
  blankNodeCss as wordCss,
} from '@lessonup/pin-renderer';
import { color, cssBase as css, cx } from '@lessonup/ui-components';
import { NodeViewRendererProps } from '@tiptap/core';
import React from 'react';
import { useFillInTheBlanksContext } from './FillInTheBlanksContext';

export const FillInTheBlanksWordNode: React.FC<NodeViewRendererProps> = ({ node }) => {
  const { isPreviewMode, hoveredId, sellectedId } = useFillInTheBlanksContext();
  const id = node.attrs['id'] as string | undefined;
  const isHovered = !!id && !isPreviewMode && hoveredId === id;
  const isSelected = !!id && !isPreviewMode && sellectedId === id;

  return (
    <TipTapNodeViewWrapper
      className={cx(wordCss, isPreviewMode && previewCss, isHovered && hooverCss, isSelected && activeCss)}
    >
      {isPreviewMode ? <span>&nbsp;</span> : <TipTapNodeViewContent />}
    </TipTapNodeViewWrapper>
  );
};

const hooverCss = css`
  background-color: ${color.neutral.surface.hover};
`;

const activeCss = css`
  background-color: ${color.state.active.fill};
  border-color: ${color.accent.secondary.background};
`;
